import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
// import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";


import Login from "../view/login/Login.vue";

// Manage products
import ListProducts from "../view/manageProducts/ListProducts";
import FormAddOrEditItem from "../view/manageProducts/FormAddOrEditItem.vue";
// Manage bill
import ListBill from "../view/billManagement/ListBill";
// Manage User
import ListUser from "../view/accountManagement/ListUser.vue";
// Manage Admins
import ListAdmin from "../view/adminManagement/ListAdmin.vue";
// Manage Customer
import ManageCustomer from "../view/customer/ManageCustomer.vue";
// Print Bill
import FormPrint from "../view/billManagement/printDeliveryBill/FormPrint.vue";
// Manage Warehoure
import ManageWarehouse from "../view/warehouseManagement/warehouseInbound.vue";
// Manage news
import ManageNews from "../view/manageNews/ManageNews.vue";
// Manage Wines Accessories 
import ManageAccessories from "../view/manageAccessories/ManageAccessories.vue";



const routes = [
  {
    name: "Login",
    path: "/",
    component: Login
  },
  {
    name: "Print",
    path: "/print-bill",
    component: FormPrint
  },
  {
    path: "/",
    component: DashboardLayout,
    children: [
      // {
      //   path: "dashboard",
      //   name: "Dashboard",
      //   components: { default: Dashboard },
      //   meta: {
      //     requiresAuth: true
      //   }
      // },
      {
        path: "manage-products",
        name: "Quản lý sản phẩm",
        components: { default: ListProducts },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "bill-management",
        name: "Quản lý đơn hàng",
        components: { default: ListBill },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "products",
        name: "Sản phẩm",
        components: { default: FormAddOrEditItem },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "customer-management",
        name: "Quản lý đại lý",
        components: { default: ManageCustomer },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "user-management",
        name: "Quản lý nhân viên",
        components: { default: ListUser },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "admin-management",
        name: "Quản lý admin",
        components: { default: ListAdmin },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "warehouse-management",
        name: "Quản lý nhập kho",
        components: { default: ManageWarehouse },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "news-managements",
        name: "Tin tức và khuyến mại",
        components: { default: ManageNews },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "wines-accessories",
        name: "Phụ kiện rượu vang",
        components: { default: ManageAccessories },
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
];

export default routes;
